import FuseAuthorization from '@fuse/core/FuseAuthorization';
import FuseLayout from '@fuse/core/FuseLayout';
import FuseTheme from '@fuse/core/FuseTheme';
import history from '@history';
import 'react-tooltip/dist/react-tooltip.css';
import { createGenerateClassName, jssPreset, StylesProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { create } from 'jss';
import ToastProvider from 'hooks/useToast';
import jssExtend from 'jss-plugin-extend';
import rtl from 'jss-rtl';
import Provider from 'react-redux/es/components/Provider';
import { Router } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import DateFnsUtils from '@date-io/date-fns';
import { ru } from 'date-fns/locale';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { useEffect } from 'react';
import AppContext from './AppContext';
import { Auth } from './auth';
import routes from './fuse-configs/routesConfig';
import store from './store';
import '../i18n';

const jss = create({
	...jssPreset(),
	plugins: [...jssPreset().plugins, jssExtend(), rtl()],
	insertionPoint: document.getElementById('jss-insertion-point')
});


const generateClassName = createGenerateClassName({ disableGlobal: true });
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			refetchOnReconnect: false,
			retry: 1
		}
	}
});

const App = () => {
	const redirectUrl = process.env.REACT_APP_REDIRECT_TO_MOBILE_URL;
	const windowWidth = window.screen.width;

	// redirect to mobile web app
	useEffect(() => {
		if (windowWidth <= 500 && redirectUrl) {
			window.location.replace(redirectUrl);
		}
	}, [windowWidth]);

	if (process.env.REACT_APP_ENV !== 'DEVELOPMENT') {
		localStorage.removeItem('baseUrl');
		localStorage.removeItem('socketBaseUrl');
	}

	if (process.env.NODE_ENV === 'development') {
		const style = document.createElement('style');
		style.innerHTML = 'iframe { display: none !important; }';
		document.head.appendChild(style);
	}

	return (
		<AppContext.Provider
			value={{
				routes
			}}
		>
			<ToastProvider>
				<StylesProvider jss={jss} generateClassName={generateClassName}>
					<Provider store={store}>
						<QueryClientProvider client={queryClient}>
							<ReactQueryDevtools initialIsOpen={false} />

							<MuiPickersUtilsProvider locale={ru} utils={DateFnsUtils}>
								<Auth>
									<Router history={history}>
										<FuseAuthorization>
											<FuseTheme>
												<SnackbarProvider
													maxSnack={5}
													anchorOrigin={{
														vertical: 'bottom',
														horizontal: 'right'
													}}
													classes={{
														containerRoot:
															'bottom-0 right-0 mb-52 md:mb-68 mr-8 lg:mr-80 z-99'
													}}
												>
													<FuseLayout />
												</SnackbarProvider>
											</FuseTheme>
										</FuseAuthorization>
									</Router>
								</Auth>
							</MuiPickersUtilsProvider>
						</QueryClientProvider>
					</Provider>
				</StylesProvider>
			</ToastProvider>
		</AppContext.Provider>
	);
};

export default App;
